/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
import { StateTransforms } from 'molstar/lib/mol-plugin-state/transforms';
import { readFile } from 'molstar/lib/mol-util/read';
import { Volume } from 'molstar/lib/mol-model/volume';
import { createVolumeRepresentationParams } from 'molstar/lib/mol-plugin-state/helpers/volume-representation-params';
import { randomColor } from '../Utils.js';


export const loadMRCfile = async (plugin, mrcFile, opacity = 0.5) => {
    const isBinary = true
    const readfile = await readFile(mrcFile, isBinary);
    const data = await plugin.builders.data.rawData({ data: readfile, label: mrcFile.name }, { state: { isGhost: true } });
    const format = plugin.dataFormats.get('ccp4');
    const parsed = await format.parse(plugin, data);
    const firstVolume = (parsed.volume || parsed.volumes[0]);
    const repr = plugin.build();
    const coloriso = randomColor();
    const isovalues = {
        type: 'absolute',
        value: 0.9,
        color: coloriso
    }
    const volume = parsed.volume;
    const volumeData = volume.cell.obj.data;
    repr.to(volume).apply(StateTransforms.Representation.VolumeRepresentation3D, createVolumeRepresentationParams(plugin, firstVolume.data, {
        type: 'isosurface',
        typeParams: { alpha: opacity, isoValue: Volume.adjustedIsoValue(volumeData, isovalues.value, isovalues.type) },
        color: 'uniform',
        colorParams: { value: isovalues.color }
    }));
    await repr.commit();
}